import standardAPI from '@/api/standard_items';

const responseUrl = '/hotels/flights';

const state = {
  flights: [],
  flights_MetaData: {},
  flights_status: '',
  flights_page: 1,
  flights_perPage: 10,
};

const getters = {
  get_flights: (state) => {
    return state.flights;
  },
  get_flights_status: (state) => {
    return state.flights_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_flights ({ commit }, getOptions) {
    commit('DATA_FLIGHTS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    console.log("Prepared options flights:", preparedOptions);
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_FLIGHTS_UPDATE_SUCCESS', response);
            commit('DATA_FLIGHTS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_FLIGHTS_READY');
            reject(response);
          } else {
            commit('DATA_FLIGHTS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_flights_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_flight ({ commit, dispatch }, itemData) {
    commit('DATA_FLIGHTS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    console.log("Flights saving", preparedData);
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_FLIGHTS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_FLIGHTS_READY');
          reject(response);
        }
      });
    });
  },
  edit_flight ({ commit, dispatch }, itemData) {
    commit('DATA_FLIGHTS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_FLIGHTS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_FLIGHTS_READY');
          reject(response);
        }
      });
    });
  },
  remove_flights ({ commit, dispatch }, itemData) {
    commit('DATA_FLIGHTS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_FLIGHTS_REQUEST');
          resolve();
        } else {
          commit('DATA_FLIGHTS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_flight ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_flight_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.flights_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.flights_perPage = max;
  },
  DATA_FLIGHTS_READY: (state) => {
    state.flights_status = 'ready';
  },
  DATA_FLIGHTS_REQUEST: (state) => {
    state.flights_status = 'loading';
  },
  DATA_FLIGHTS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.flights_MetaData.meta = response.meta;
      state.flights_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.flights = response.data || [];
    }
    state.flights_status = 'success';
  },
  DATA_FLIGHTS_ERROR: (state) => {
    state.flights_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
